import $ from 'jquery'

export default class PageContentOpacity {
  static init () {
    const menus = document.getElementsByClassName('is-menu')

    for (const menu of menus) {
      menu.addEventListener('mouseenter', (event) => {
        const navigationIsFixed = document.getElementsByClassName('navigation-fixed')

        if (navigationIsFixed.length > 0) {
          return
        }

        $('#content-container, .footer').addClass('reduce-opacity')
        $('#content-container, .footer').removeClass('grow-opacity')
      })
      menu.addEventListener('mouseleave', (event) => {
        $('#content-container, .footer').addClass('grow-opacity')
        $('#content-container, .footer').removeClass('reduce-opacity')
      })
    }
  }
}
